import _ from 'lodash';

import { TasksResults } from '@scale/shared/types/api/internal/customerTasks';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';
import { PagedTasksElasticParams } from '@scale/shared/types/endpoints/customer/studio/task';
import { TaskDownloadCustomerDashboardRequestDTO } from '@scale/shared/chatDeliveryBuilder/dto';
import { useMutation } from 'react-query';

export async function getAllTaskTypes() {
  return apiFetch(null, 'internal/tasks/types');
}

export async function getAvailableTaskTypes(query: $FIXME = {}) {
  return apiFetch(null, 'internal/tasks/available-types', { query });
}

export async function getTotalTasksCountInProject(projectId: string) {
  return apiFetch(null, 'internal/tasks/all_tasks_count', { query: { projectId } });
}

// Task list query from Scale Pro dashboard
export async function getPagedTasks(params: $FIXME = {}): Promise<TasksResults> {
  const query = _.omitBy(params, _.isNil);
  return apiFetch(null, `internal/tasks/paged`, { query });
}

export async function getPagedTasksElastic(params: PagedTasksElasticParams): Promise<TasksResults> {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/tasks/paged/elastic`, {
    method: 'POST',
    body,
  });
}

export async function getRandomOrder(params: $FIXME = {}) {
  const query = _.omitBy(params, _.isNil);
  return apiFetch(null, `internal/tasks/random-order`, { query });
}

export function useGetExportTasksAsyncMutation() {
  return useMutation<{ arn: string }, string, TaskDownloadCustomerDashboardRequestDTO>({
    mutationFn: async body => {
      return await apiFetch(null, `internal/tasks/tasks_download_email_delivery`, {
        method: 'POST',
        body,
      });
    },
  });
}

export async function emailAllTaskResults(projectId: string, batchIds?: string[]) {
  try {
    await apiFetch(null, `internal/tasks/email-all-results`, {
      method: 'POST',
      body: {
        projectId,
        batchIds,
      },
    });
  } catch (e) {
    defaultApiFetchErrorHandler(e, { handleHttp: true });
    throw e;
  }
}

export async function sendAuditCompletedCallback(projectId: string, batchIds?: string[]) {
  try {
    await apiFetch(null, `internal/tasks/send-audit-completed`, {
      method: 'POST',
      body: {
        projectId,
        batchIds,
      },
    });
  } catch (e) {
    defaultApiFetchErrorHandler(e, { handleHttp: true });
    throw e;
  }
}

export async function resendCallback(taskId: string, isLive: boolean) {
  try {
    await apiFetch(null, `internal/tasks/resend-task-callback`, {
      method: 'POST',
      body: {
        taskId,
        isTest: !isLive,
      },
    });
  } catch (e) {
    defaultApiFetchErrorHandler(e, { handleHttp: true });
    throw e;
  }
}

export async function cancelTasks(taskId: string, isLive: boolean): Promise<$FIXME> {
  try {
    return await apiFetch(null, `internal/tasks/${taskId}/cancel`, {
      method: 'POST',
      query: {
        isTest: !isLive || undefined,
      },
    });
  } catch (e) {
    defaultApiFetchErrorHandler(e, { handleHttp: true });
    throw e;
  }
}

export async function pinTask(taskId: string, message?: string): Promise<any> {
  try {
    return await apiFetch(null, `internal/tasks/${taskId}/pin-task`, {
      method: 'POST',
      body: {
        message,
      },
    });
  } catch (e) {
    defaultApiFetchErrorHandler(e, { handleHttp: true });
    throw e;
  }
}

export async function unpinTask(taskId: string): Promise<any> {
  try {
    return await apiFetch(null, `internal/tasks/${taskId}/unpin-task`, { method: 'POST' });
  } catch (e) {
    defaultApiFetchErrorHandler(e, { handleHttp: true });
    throw e;
  }
}
